export const PERSONAL = 'duplicate_uniform_invoice';
export const COMPANY = 'triplicate_uniform_invoice';
export const DONATION = 'donated_invoice';



// WEBPACK FOOTER //
// ./app/constants/eInvoiceTypes.js